module.exports = __webpack_public_path__ + "img/glow-blue-small.a9fcf18a.png";